<template>
  <div class="leadlist-step-3">
    <form-group
      select
      id="event"
      placeholder="Selecionar..."
      label="Quando o seguinte evento acontecer"
      :options="typeEvents"
      v-model="form.event"
    />
    <form-group
      select
      id="commands"
      placeholder="Selecionar..."
      label="O comando a seguir será executado no provedor"
      :options="typeCommands.filter(t => t.name === 'Adicionar tag ao contato')"
      v-model="form.command"
    />
    <form-group
      v-if="provider && provider.name === 'leadlovers'"
      v-model="form.tag"
      select
      slim
      id="tags"
      label="Selecione uma tag"
      placeholder="Selecionar..."
      :errors="errors.tag"
      :options="[...tags]"
    />

    <template v-if="provider && provider.name === 'rdstation'">
      <tag-input
        label="Tags"
        v-model="form.tags"
        placeholder="Separe as tags com vírgulas"
        class="m-0 mt-3"
      />
      <form-group
        class="mt-3"
        id="event-conversion"
        placeholder="Nome do evento de conversão"
        label="Nome do evento de conversão (opcional)"
        v-model="form.event_conversion_id"
      />
    </template>
  </div>
</template>

<script>
import { clearObject } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("integration", ["typeEvents", "typeCommands", "tags"])
  },
  data: () => ({ tag_options: [], loadingTags: false }),
  mounted() {
    this.fetchTags();
    this.dispatchTypeEvents();
    this.dispatchTypeCommands();
  },
  methods: {
    fetchTags() {
      if (!this.provider) return;

      this.loadingTags = true;

      this.$store
        .dispatch(
          "integration/getLeadLoversTags",
          clearObject({
            provider_id: this.provider.id
          })
        )
        .then()
        .finally(() => {
          this.loadingTags = false;
        });
    },
    dispatchTypeEvents() {
      this.loading = true;
      this.$store
        .dispatch("integration/getTypeEvents")
        .then()
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível carregar os provedores");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dispatchTypeCommands() {
      this.loading = true;
      this.$store
        .dispatch("integration/getTypeCommands")
        .then()
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível carregar os provedores");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
